module.exports = __webpack_public_path__ + "img/cloudflare-logo.9f673b1a.svg";